import dayjs from 'shared/helpers/dayjs';
import { UrgencyStatistic } from 'dashboard/hooks/useUrgencyStatistics';

export default function aggregateByMonth(
  data: UrgencyStatistic[]
): UrgencyStatistic[] {
  const grouped = new Map<string, UrgencyStatistic>();
  data.forEach((item) => {
    const monthStart = dayjs(item.date).startOf('month').format('YYYY-MM-DD');
    const existing = grouped.get(monthStart);
    if (existing) {
      existing.emergency += item.emergency;
      existing.needs_attention += item.needs_attention;
      existing.routine += item.routine;
      existing.informational += item.informational;
    } else {
      grouped.set(monthStart, { ...item, date: monthStart });
    }
  });
  return Array.from(grouped.values());
}
